module.exports = __webpack_public_path__ + "images/emoji/heart.6cdfd2968fdede065f60.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/heart.png
// module id = ay9A
// module chunks = 1